<template>
  <div class="channel_window channel-modal-popup">
    <button @click="viewChannel" v-if="!hideChannelIcon" class="ace_sec btn_ic">
      <span v-if="unreadCount > 0">
        <span class="ic ic9-channel2" style="font-size: 37px;">
          <span class="unread-count">{{unreadCount}}</span>
          <span class="unread-count-red-dot"></span>
        </span>
      </span>
      <span v-else>
        <span class="ic ic8-channel" style="font-size: 37px;"></span>
      </span>
    </button>
    <div>
      <b-modal id="send-group-message-popup" class="full_screen_modal" ref="sendGroupMessageModal" :header-bg-variant="'send-group-message-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt head_txt">
            <span v-if="userIds.length > 1">Sending Channel Message To {{userIds.length}} People</span>
            <span v-else>{{sendGroupMessageText.replace('Sending', 'Sending Channel')}}</span>
          </div>
          <div>
            <button class="btn_close" aria-label="close" @click="cancelSendGroupMessage">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="ch_mid_sec">
          <div class="text-center">
            <span class="msg_to_user">{{sendGroupMessageText}}</span>
          </div>

          <div class="channel-section msg_sec_container">
            <div class="msg_row_section">
              <div class="msg_section_inner">
                <div class="chat-message" style="margin-bottom: 2px;" v-for="message in sendMessages">
                  <div class="message-avatar-default">
                    <span class="icon-user"></span>
                  </div>
                  <div class="message-details">
                    <div class="message-author-name">
                      <span class="message-author">{{message.name}}</span>
                      <span class="message-time">{{get12HourTime(message.date)}}</span>
                    </div>
                    <div class="message">
                      <div class="message-content float-left" v-html="message.text"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field-section" v-if="action == 'sendGroupMessage'">
          <label for="groupRichTextMessage" class="visibility_hide">Add message</label>
          <editor api-key="no-api-key"
            v-model.trim="sendMessage"
            :init="({
              base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
              menubar: false,
              plugins: plugins,
              toolbar: toolbar,
              branding: false,
              statusbar: false,
              end_container_on_empty_block: true
            })"
            @onInit="handlerInit"
            @onKeyUp="handlerKeyUp"
            id="groupRichTextMessage">
          </editor>
          <div class="right-section rich-text-editor-btn">
            <div class="send_btn_container">
              <button type="submit" value="send" class="send-btn btn" @click="send(true)">
                <span class="ic9-send ic9-iconSend-0001">
                  <span class="visibility_hide">send</span>
                </span>
              </button>
            </div>
          </div>
          <div class="left-section channel-dropdown">
              <b-dropdown no-caret>
                <template slot="button-content">
                  <span class="icon icon-channel" v-if="messageType == 'Message'">
                    <span class="visibility_hide">channel</span>
                  </span>
                  <span class="icon icon-bell" v-if="messageType == 'Urgent Notification'"></span>
                  <span class="icon icon-bullhorn" v-if="messageType == 'Recommendation'"></span>
                  <span class="icon-dropdown2"></span>
                </template>
                <b-dropdown-item @click="changeType('Recommendation')" :disabled="messageType === 'Recommendation'">
                  <span class="icon icon-bullhorn"></span>
                  <span class="text">Recommendation</span>
                </b-dropdown-item>
                <b-dropdown-item @click="changeType('Urgent Notification')" :disabled="messageType === 'Urgent Notification'">
                  <span class="icon icon-bell"></span>
                  <span class="text">Urgent Notification</span>
                </b-dropdown-item>
                <b-dropdown-item @click="changeType('Message')" :disabled="messageType === 'Message'">
                  <span class="icon icon-channel"></span>
                    <span class="text">Message</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>

        </div>
        <div class="mt-3">
          <div class="float-right" v-if="sendMessage.length > 10">
            <span class="mr-3"><small><b>Enter</b> to send</small></span>
            <span><small><b>Shift + Enter</b> to add a new line</small></span>
          </div>
        </div>
      </b-modal>
    </div>
    <bad-words-prompt ref="badWordsAlert" @sendMaskedBadWords="sendMaskedBadWords" :editorInstanceId="'groupRichTextMessage_ifr'"></bad-words-prompt>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapActions } from 'vuex'
  import Editor from '@tinymce/tinymce-vue'
  import { db } from '../../../firebase'
  import { StorageFactory } from '../../../storageFactory'
  import BadWordsPrompt from '../../channel/components/BadWordsPrompt'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'channel-action-menu',
    props: ['action', 'userIds', 'senderId', 'hideChannelIcon'],
    components: {
      Editor,
      BadWordsPrompt
    },
    data: () => {
      return {
        messages: [],
        unreadList: [],
        unreadCount: 0,
        sendMessage: '',
        sendMessages: [],
        currentChannel: [],
        userChannelIdMap: {},
        uuidDisplayNameMap: {},
        messageType: 'Message',
        sendGroupMessageText: '',
        groupMessageUserNames: [],
        isActionModalVisible: false,
        userId: localStore.getItem('userid'),
        userRole: localStore.getItem('userrole'),
        userName: localStore.getItem('userFullName'),
        plugins: 'lists  autolink charmap code hr link textcolor',
        toolbar: 'bold italic strikethrough | bullist numlist | indent outdent | alignleft aligncenter alignright | forecolor backcolor | removeformat link unlink'
      }
    },
    async created () {
      let userUuids = _.map(this.userIds, 'userUuid')
      this.userChannelIdMap = await this.loadPlanningStreamIdsForSelectedUsers(userUuids)
      this.currentChannel = this.userChannelIdMap[userUuids[0]]
      this.$bindAsArray('unreadList', db.ref('Unread/' + this.userId))
    },
    watch: {
      unreadList (newUnreadList) {
        let data = _.find(newUnreadList, (data) => {
          return (this.currentChannel === data.channelId)
        })
        if (data) {
          this.unreadCount = this.$parent.unreadCount = data.unreadCount
        }
      }
    },
    methods: {
      ...mapActions([
        'updateUnread',
        'loadParticipantDisplayNames',
        'loadPlanningStreamIdsForSelectedUsers'
      ]),
      async viewChannel () {
        let userUuids = _.map(this.userIds, 'userUuid')
        this.uuidDisplayNameMap = await this.loadParticipantDisplayNames(userUuids)
        if (this.action === 'view') {
          return this.$router.push({name: 'courseSectionChannel', params: {uuid: this.userId, selectedCurrentChannel: this.currentChannel, channelType: 'ALL', isShowBack: true}})
        } else if (this.action === 'sendGroupMessage') {
          this.groupMessageUserNames = Object.values(this.uuidDisplayNameMap)
          this.sendGroupMessageText = 'Sending Message to '
          if (userUuids.length > 1) {
            this.sendGroupMessageText += userUuids.length + ' people including ' + this.groupMessageUserNames.join(', ').replace(/,(?=[^,]*$)/, ' and')
          } else {
            this.sendGroupMessageText += this.groupMessageUserNames[0]
          }
          setTimeout(() => {
            this.isActionModalVisible = true
            this.$refs.sendGroupMessageModal.show()
            $('.advisee_sec_crd').addClass('active')
          }, 500)
        }
      },
      changeType (type) {
        this.messageType = type
      },

      cancelSendGroupMessage () {
        this.messages = []
        this.sendMessage = ''
        this.sendMessages = []
        this.uuidDisplayNameMap = {}
        this.sendGroupMessageText = ''
        this.groupMessageUserNames = []
        this.isActionModalVisible = false
        this.$refs.sendGroupMessageModal.hide()
        this.$parent.$parent.selectedUserUuids = []
        this.$parent.$parent.selectedItemMessage=''
        this.$parent.$parent.pageSelected = false
        $('.advisee_sec_crd').removeClass('active')
      },
      preventEnterKeyEvent (container, ed) {
        $(container).keydown((e) => {
          const keyPressed = e.keyCode || e.which
          if ((keyPressed === 13) && !e.shiftKey) {
            let content = ed.getContent().replace(/<p>&nbsp;<\/p>/g, '')
            ed.setContent(content)
            ed.selection.select(ed.getBody(), true)
            ed.selection.collapse(false)
            return false
          }
        })
      },
      handlerInit (ev, editor) {
        $('#groupRichTextMessage_ifr').width('calc(100% - 60px)')
        $('#groupRichTextMessage_ifr').height('72px')
        $('.field-section').css('visibility', 'visible')
        let container = $('#groupRichTextMessage_ifr')[0].contentWindow.document.body
        this.preventEnterKeyEvent(container, editor)
        $('.mce-top-part').css({'width': '100%', 'padding-left': '0px'})
      },
      handlerKeyUp (ev, editor) {
        const keyPressed = ev.keyCode || ev.which
        if (((keyPressed === 13) && !ev.shiftKey) || ((keyPressed === 17) && (ev.target.innerHTML.indexOf('<img') !== -1))) {
          let isBadWordsNotAllowed = (keyPressed === 13) || (ev.target.innerHTML.indexOf('<img') === -1)
          this.send(isBadWordsNotAllowed)
        }
      },
      sendMaskedBadWords () {
        this.send(false)
      },
      async send (isBadWordsNotAllowed) {
        if (this.sendMessage.length > 0) {
          let isNotAllowed = this.$refs.badWordsAlert.showPrompt(this.sendMessage, isBadWordsNotAllowed)
          if (!isNotAllowed) {
            this.sendMessage = this.sendMessage.replaceAll(/<p style=.*>&nbsp;<\/p>/g, '').replaceAll(/<p>&nbsp;<\/p>/g, '')
            if (this.sendMessage && this.sendMessage.length > 1) {
              this.sendMessage = this.sendMessage.replaceAll('<a', '<a style="color: #0645AD;" target="_blank" rel="noopener"')
              this.sendMessage = this.sendMessage.replace('<img', '<img style="width: 350px; height: 200px; cursor: zoom-in;" class="open-img-modal"')
              this.sendMessage = this.$refs.badWordsAlert.maskBadWords(this.sendMessage)
              let date = new Date()
              let dd = date.getDate()
              let mm = date.getMonth() + 1
              let yyyy = date.getFullYear()
              let hr = date.getHours()
              let mn = date.getMinutes()
              if (mn < 10) {
                mn = '0' + mn
              }
              const message = {
                name: this.userName,
                role: this.userRole,
                uuid: this.userId,
                text: this.sendMessage,
                date: mm + '/' + dd + '/' + yyyy + ' ' + hr + ':' + mn,
                type: this.messageType
              }
              this.sendMessageToUsers(message)
            }
          }
        }
      },
      async sendMessageToUsers (message) {
        let selectedUserIds = _.map(this.userIds, 'userUuid')
        this.uuidDisplayNameMap = await this.loadParticipantDisplayNames(selectedUserIds)
        this.userChannelIdMap = await this.loadPlanningStreamIdsForSelectedUsers(selectedUserIds)
        selectedUserIds.forEach(selectedUserId => {
          let channelId = this.userChannelIdMap[selectedUserId]
          if (channelId) {
            this.$bindAsArray('messages', db.ref('channels/' + channelId + '/Messages'))
            this.$firebaseRefs.messages.push(message)
            this.updateUnreadForUser(channelId, selectedUserId)
          }
          this.updateUnread({channelId: channelId, unread: 0})
        })
        this.sendMessage = ''
        this.sendMessages.push(message)
      },
      updateUnreadForUser (channelId, selectedUserId) {
        if (channelId) {
          let messageId
          this.$firebaseRefs.messages.limitToLast(1).once('child_added', (child) => {
            messageId = child.key
          })
          let lastItem = {unreadCount: 0, lastUnreadMessageId: messageId}
          let dbRef = db.ref('Unread/' + selectedUserId)
          dbRef.child(channelId).on('value', (snapshot) => {
            let child = snapshot.val()
            if (child !== null) {
              lastItem.unreadCount = child.unreadCount
              lastItem.lastUnreadMessageId = child.lastUnreadMessageId
            }
          })
          let unreadCount = lastItem.unreadCount + 1
          dbRef.child(channelId).set({
            uuid: this.userId,
            channelMessage: true,
            channelId: channelId,
            unreadCount: unreadCount,
            lastUnreadMessageId: lastItem.lastUnreadMessageId
          })
          this.updateUnread({channelId: channelId, unread: unreadCount})
        }
      },
      get12HourTime (datetime) {
        let values = datetime.split(' ')
        let hrmn = values[1].split(':')
        let hr = hrmn[0]
        let mn = hrmn[1]
        let ampm = hr >= 12 ? 'pm' : 'am'
        hr = hr % 12
        hr = hr ? hr : 12
        let time = values[0] + ' ' + hr + ':' + mn + ' ' + ampm
        return time
      }
    }
  }
</script>

<style>
  .action-icon-channel {
    color: #157099;
    font-size: 38px;
  }

  .popup_head_txt {
    color: #323232;
    font-weight: 800;
    font-size: 1.4rem;
  }

  .bg-send-group-message-popup-header {
    background: #eaf8ff !important;
  }

  #groupRichTextMessage {
    height: 86px;
    width: calc(100% - 85px);
    padding-left: 6px;
  }

  .unread-count {
    color: #fff;
    font-size: 15px;
    margin: 8px -22px;
    position: absolute;
  }

  .unread-count-red-dot {
    width: 10px;
    height: 10px;
    margin: 3px -12px;
    position: absolute;
    border-radius: 50%;
    border: 1px solid #ccc;
    background-color: #c31a00;
  }
  .left-section.channel-dropdown {
    position: absolute;
    left: 0;
    top: 24px;
  }
  .left-section.channel-dropdown button, .left-section.channel-dropdown button:active {
    background: transparent;
  }
  .left-section.channel-dropdown button .icon, .icon-dropdown2 {
    color: rgb(204, 204, 204);
    margin: 0;
  }
  .left-section.channel-dropdown button .icon-dropdown2 {
    font-size: 20px;
  }
  .left-section.channel-dropdown .icon-channel {
    float: left;
    margin-left: -2px;
    margin-right: 6px;
  }
  .left-section.channel-dropdown .dropdown-item {
    min-width: 212px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .left-section.channel-dropdown .dropdown-item.disabled .icon {
    color: rgb(204, 204, 204);
  }
  .send-btn.btn {
    padding: 14px 20px !important;
  }
  #groupRichTextMessage, .field-section iframe {
    margin-left: 60px;
    width: calc(100% - 140px) !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/ChannelActionMenu.vue